import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const trademarkToken = localStorage.getItem("trademark-membership-user");
  const userTrademarkToken = localStorage.getItem("userInfo");

  return trademarkToken && userTrademarkToken ? children : <Navigate to={{ pathname: "/login" }} replace />;
}

PrivateRoute.propTypes = {
  children: PropTypes.element,
};

export default PrivateRoute;
